module.exports = __webpack_public_path__ + "static/media/delete-icon-green.dacff98c.svg";